import React from 'react';
import { View, StyleSheet, Image, ActivityIndicator, ImageBackground, TouchableWithoutFeedback, Platform, KeyboardAvoidingView, TouchableOpacity, Clipboard } from 'react-native';

import AsyncStorage from '@react-native-community/async-storage';

import { Snackbar, TextInput, Button, Surface } from 'react-native-paper';

import { verifyOtp, dispatchClearOtp, login,  } from './../../store/actions';
import { connect } from 'react-redux';
import Toaster from './../../components/snackBar_toaster';


import Timer from './../../components/timer';

// import OfflineHandler from './../OfflineHandler';

import { Styles, Text } from './../../components/UI-Components';
// import Colors from './../../constants/theme';
import OtpInput from 'react-otp-input';


class TimerComponent extends React.Component {

    shouldComponentUpdate() {
        return false;
    }

    render() {
        return (
            <Timer {...this.props} />
        )
    }
}



const isIos = Platform.OS === "ios";
class OtpScreen extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            snackbarMsg: '',
            _deviceInfo: null,
            hideResendBtn: true,
            text: '',
            pinCount: 6,
            code: undefined,
            numInputs: 6
        }
    }

    componentWillUnmount() {
        // this.props.dispatchClearOtp();        

    }

    async componentDidUpdate(prevProps) {

        let goToHome = true;



        if (this.props.authToken !== prevProps.authToken) {
            if (this.props.authToken) {
                this._storeData(this.props.authToken);

                // this.refs.toast.show('Your registration for 2thePoint is Successful. Enjoy the Free Trial version for 15 days', 1000)           
                this.showSnackBar('Successfully logged in.')

                setTimeout(() => {
                    this.setState({ code: undefined })
                }, 2000);


                setTimeout(() => {
                    this.props.history.replace('/Home');
                }, 1500)


                // firebaseLogEvent('login_successfully', {});

            }
        }

        if (prevProps.errInfo !== this.props.errInfo) {
            if (this.props.errInfo) {
                this.showSnackBar(this.props.errInfo)
                this.setState({ code: undefined })
                // this.setState({
                //     visible: true,
                //     snackbarMsg: this.props.errInfo
                // })
            }
        }

    }






    async componentDidMount() {
        // console.log(this.props.match, 'props');
    }

    showSnackBar = msg => {
        this.setState({
            visible: true,
            snackbarMsg: msg
        })
    }


    resendOTP = () => {
        const { mobileNo, login, history, match } = this.props;
        // console.log(mobileNo, "asflas;f")
        if (mobileNo) {
            this.setState({
                hideResendBtn: true
            })
            login(mobileNo);
        } else {
            setTimeout(() => {
                history.goBack();
            }, 600);
        }
    }

    _storeData = async (key) => {
        try {
            await AsyncStorage.setItem('authKey', key);
            const value = await AsyncStorage.getItem('authKey');
            // console.log(value, 'authentication key from otpscreen')
            if (value !== null) {
                // We have data!!
                // console.log(value, 'stored value');

            }
        } catch (error) {
            // Error saving data
            // console.log(error, 'async error');
        }

    }



    _onFulfill = (code) => {

        this.setState({
            otp: code
        })

        this.props.verifyOtp(this.props.mobileNo, code);
    }

    handleChange = otp => {
        this.setState({
             otp 
            }, () => {
                
                const { otp } = this.state;
                 let _otp =[];
                 _otp.push({..._otp, Otp: `${otp}`});
                
                if(_otp[0].Otp.length === this.state.numInputs){
                    const {params} = this.props.match || {};
                    const {mobile} = params || {};
                    // console.log(otp, mobile, otp.length, !!mobile);
                    if (otp && String(otp).length >= 6 && mobile) {
                        return this.props.verifyOtp(mobile, otp);
                    }
                    this.showSnackBar('Incorrect otp')
                }
            })
    };

    render() {
        const { visible } = this.state;
        const { resendOtpLoading, loading, match } = this.props;
        // console.log(this.props.mobileNo, "asfaslfas")

        return (
            <div
             className='loginBox'
             style={{display: 'flex', 
             justifyContent: 'center',
              alignItems: 'center'
             }}
            >
                    <div 
                    style={{
                        flexDirection: 'column',
                        display: 'flex',
                        width: '50%',
                        padding: 25,
                        justifyContent: 'center',
                        alignItems: 'center',
                        // paddingVertical: 30,
                        // borderRadius: 5,
                        // boxShadow: '0px 1px 1px 1px rgba(0,0,0,0.6)'
                        }}>

                        {/* <View style={{ justifyContent: 'center', alignItems: 'center' }}>
                            <Image source={require('./../../assets/otp_phone.png')} style={{ width: 90, height: 80 }} />
                        </View> */}
                        <View style={{  marginTop: -20, marginBottom: 20, alignItems: 'center'}}>

                        <Text style={{ color: '#222', fontSize: 40,  fontWeight: '600', marginTop: 15 }}>Code Verification </Text>
                        <View style={{ flexDirection: 'row', marginTop: 5 }}>
                            <Text style={{ color: '#999b9e', fontSize: 13, }}>
                                {/* OTP sent to  your mobile number or email */}
                                We will send you an One Time Password to your registered mobile number
                            </Text>
                            {/* <Text style={{marginLeft:5,fontSize: 13,}}>{this.props.navigation.getParam('mobile')}</Text> */}
                        </View>
                        </View>
                        {/* <Text style={{ color: '#222', fontSize: 25, textAlign: 'center' }}>Verification Code</Text> */}
                        {/* <Text style={{ color: '#222', fontSize: 16, marginTop: 15, textAlign: 'center', color: '#29355f', marginHorizontal: 30 }}>
                                              OTP has been sent to your mobile number.
                                                 Please verify
                                        </Text> */}
                        <View style={{ justifyContent: 'center', alignItems: 'center' }}>
                            {/* <OTPInputView
                                                //  ref="codeInputRef1"
                                                ref={x => this.otpInput = x}
                                                // ref={x => console.log(x)}
                                                style={{width: '70%', height: 100,}}
                                                code={this.state.code}
                                                //  className={'border-b'}
                                                //  space={5}
                                                //  size={30}
                                                //  codeLength={6}
                                                //  inputPosition='center'
                                                //  activeColor='#29355F'
                                                //  inactiveColor='#29355F'
                                                 autoFocusOnLoad={true}
                                                //  ignoreCase={true}
                                                // onCodeChanged={() => alert('')}
                                                 codeInputFieldStyle={styles.underlineStyleBase}
                                                 codeInputHighlightStyle={styles.underlineStyleHighLighted}
                                                 onCodeFilled ={(code) => {
                                                    this._onFulfill(code)
                                                        // let _code = code.split('');
                                                        // let index = code.length;
                                                        // console.log(index);
                                                        // const lastIndex = _code[index - 1]
                                                        // alert(code.length === this.state.pinCount)
                                                        // alert(JSON.stringify(lastIndex))
                                                    
                                                }}
                                          
                                                 
                                             /> */}


                            <OtpInput
                                onChange={this.handleChange}
                                numInputs={6}
                                value={this.state.otp}
                                // separator={<span>-</span>}
                                shouldAutoFocus
                                containerStyle={{
                                    marginTop: 24,
                                    marginBottom: 24,
                                   
                                }}
                                inputStyle={{
                                    padding: 12,
                                    marginLeft: 8,
                                    marginRight: 8,
                                    backgroundColor: Styles.fiveMantraBgColor,
                                    color: Styles.primaryColor,
                                    fontSize: 15,
                                    borderTop:0,
                                    borderLeft:0,
                                    borderRight: 0,
                                    borderBottom: `1px solid ${Styles.primaryColor}`
                                    // borderBottomWidth: 1
                                }}
                                hasErrored
                                isInputNum
                            />

                        </View>
                        {


                            <Button style={styles.goButton}
                                disabled={loading || this.props.status ? true : false}
                                //  disabled={this.otpInput && this.otpInput.state && this.otpInput.state.digits && this.otpInput.state.digits.length >=6 ? false : true }
                                mode="contained"
                                onPress={() => {
                                    // alert(JSON.stringify(this.otpInput.getDigits()));

                                    const { otp } = this.state;
                                    const {params} = match || {};
                                    const {mobile} = params || {};
                                    // console.log(otp, mobile, otp.length, !!mobile);
                                    if (otp && String(otp).length >= 6 && mobile) {
                                        return this.props.verifyOtp(mobile, otp);
                                    }
                                    this.showSnackBar('Incorrect otp')

                                }}
                                loading={this.props.loading ? true : false}
                            >
                                Proceed
                                                </Button>

                        }
                        <View>
                            {
                                loading || resendOtpLoading ?

                                    (
                                        <View style={{ justifyContent: 'center', alignItems: 'center', flex: 1, marginTop: 8 }}>
                                            {/* <ActivityIndicator /> */}
                                            {/* {
                                                                    loading && (<Text style={{ textAlign: 'center', color: '#1a2b63' }}>
                                                                        'Verifying Please Wait....'
                                                                    </Text>)
                                                                } */}

                                            {
                                                resendOtpLoading && (<Text style={{ textAlign: 'center', color: '#1a2b63' }}>
                                                    'Please Wait....'
                                                </Text>)
                                            }

                                        </View>
                                    )

                                    : null
                            }
                        </View>
                        {
                            this.state.hideResendBtn &&
                            <View style={{ marginTop: 22 }}>
                                {
                                    !this.state.hideResendBtn ? <View />
                                    :
                                     <View style={{flex: 1, justifyContent: 'center', alignItems: 'center'}}>

                                         <TimerComponent 
                                             style={{ textAlign: "center", }}
                                             timer={1}
                                             onSubmit={() => this.setState({
                                                  hideResendBtn: false 
                                             })}
                                         />
                                     </View>
                                }
                            </View>
                        }
                        <View style={{ marginTop: 8 }}>
                            <Text style={{ marginBottom: 20, textAlign: 'center', marginTop: 10 }}>Didn't you receive verification code</Text>
                        </View>

                        <View style={{ marginBottom: 20 }}>
                            {
                                !this.state.hideResendBtn &&
                                //  <Button
                                //      disabled={resendOtpLoading || loading}
                                //      style={{ borderRadius: 25 }}
                                //      title={'RESEND OTP'}
                                //      onPress={() => {
                                //          this.resendOTP();
                                //      }}
                                //  />
                                <View style={{ justifyContent: 'center', alignItems: 'center' }}>
                                    <div
                                        // title={'RESEND OTP'}
                                        onClick={() => {
                                            
                                            this.resendOTP();
                                        }}>

                                        <Text style={{ color: 'red' }}>Resend OTP</Text>
                                    </div>

                                </View>
                            }
                        </View>
                        <View>
                        </View>
                        <Snackbar
                            style={{ backgroundColor: '#fff', color: '#222', flex: 1, justifyContent: 'flex-end', bottom: 0 }}
                            visible={this.state.visible}
                            onDismiss={() => this.setState({ visible: false })}
                            action={{
                                label: 'close',
                                onPress: () => {
                                    this.setState({ visible: false })
                                },
                            }}
                        >
                            <Text style={{ color: '#000' }}>{this.state.snackbarMsg}</Text>
                        </Snackbar>


                    </div>
                


            </div>
           

        )
    }
}

const styles = StyleSheet.create({
    container: {
        borderWidth: 3,
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: 10,
    },
    mainContainer: {
        // flex: 1,
        // justifyContent: 'center',
        // align/Items: 'center',
        // backgroundColor: '#2f2f2f',
        // paddingBottom:20
    },
    splashBackgroundImage: {
        width: '100%',
        height: '100%',
    },
    borderStyleBase: {
        width: 30,
        height: 45
    },

    borderStyleHighLighted: {
        borderColor: "#03DAC6",
    },

    underlineStyleBase: {
        width: 30,
        height: 45,
        borderWidth: 0,
        borderBottomWidth: 1,
    },

    underlineStyleHighLighted: {
        borderColor: "#03DAC6",
    },
    goButton: {
        width: 200,
        borderRadius: 10,
        backgroundColor: '#f9c741',
        // borderRadius: 15,n
        borderWidth: 2,
        borderColor: '#fff',
       height: 50, 
       marginBottom: 20,
       marginTop: 20,
       justifyContent: 'center',
       alignItems:'center',
        alignSelf : 'center' 

    }
    
})

const mapStateToProps = state => ({
    mobileNo: state.login && state.login.mobile && state.login.mobile,
    loading: state.otpVerify && state.otpVerify.loading && state.otpVerify.loading,
    err: state.otpVerify && state.otpVerify.err,
    errInfo: state.otpVerify && state.otpVerify.errInfo && state.otpVerify.errInfo.data && state.otpVerify.errInfo.data.message,
    status: state.otpVerify.response && state.otpVerify.response.status && state.otpVerify.response.status,
    firstTimeLogin: state.otpVerify.response && state.otpVerify.response.data && state.otpVerify.response.data.first_time_login && state.otpVerify.response.data.first_time_login,
    fundAccountStatus: state.otpVerify.response && state.otpVerify.response.data && state.otpVerify.response.data.fundAccountStatus,
    appVersion: state.otpVerify.response && state.otpVerify.response.data && state.otpVerify.response.data.os_version,
    authToken: state.otpVerify.response && state.otpVerify.response.data && state.otpVerify.response.data.token && state.otpVerify.response.data.token,
    resendOtpLoading: state.login && state.login.loading,
    resendOtpErr: state.login && state.login.err,
    resendOtpResponse: state.login.response && state.login.response,
})

export default connect(mapStateToProps, { verifyOtp, dispatchClearOtp, login })(OtpScreen);
